"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExceptionReasonsState = exports.ExceptionReasonsContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const getExceptionReasons_1 = require("../api/getExceptionReasons");
const ExceptionReasonsContext = (0, react_1.createContext)({});
const ExceptionReasonsContextProvider = ({ children, isInternalActivitiesEnabled, }) => {
    const exceptionReasonsResponse = (0, getExceptionReasons_1.useExceptionReasons)(isInternalActivitiesEnabled);
    const getExceptionReasonsMap = (reasons) => {
        if (!reasons || !Array.isArray(reasons))
            return {};
        return reasons.reduce((map, reason) => ({ ...map, [reason.id]: reason }), {});
    };
    const getExceptionPartiesMap = (reasons) => {
        if (!reasons || !Array.isArray(reasons))
            return {};
        return reasons.reduce((exceptionResponsibleMap, exceptionReason) => {
            return {
                ...exceptionResponsibleMap,
                ...exceptionReason.parties.reduce((accumulated, party) => ({
                    ...accumulated,
                    [party.id]: party,
                }), {}),
            };
        }, {});
    };
    const state = (0, react_1.useMemo)(() => ({
        exceptionReasons: getExceptionReasonsMap(exceptionReasonsResponse?.data),
        parties: getExceptionPartiesMap(exceptionReasonsResponse?.data),
    }), [exceptionReasonsResponse]);
    return (0, jsx_runtime_1.jsx)(ExceptionReasonsContext.Provider, { value: state, children: children });
};
exports.ExceptionReasonsContextProvider = ExceptionReasonsContextProvider;
const useExceptionReasonsState = () => {
    const context = (0, react_1.useContext)(ExceptionReasonsContext);
    if (!context) {
        throw new Error('Must use useExceptionReasonsState in ExceptionReasonsContext');
    }
    return context;
};
exports.useExceptionReasonsState = useExceptionReasonsState;
//# sourceMappingURL=ExceptionReasonsContext.js.map